import {HttpClient} from "../../service/httpClient/HttpClient";

export class NotificationsService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getNotificationList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-announcements`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewNotification(title, authorInformation, description, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `site-announcements`,
                {
                    "title": title,
                    "authorInformation": authorInformation,
                    "description": description,
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getNotificationDetail(notificationId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-announcements/${notificationId}`
            ).then(resolve).catch(reject)
        })

    }

    updateNotification(title, authorInformation, description, enabled, newsId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `site-announcements/${newsId}`,
                {
                    "title": title,
                    "authorInformation": authorInformation,
                    "description": description,
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteNotification(title, authorInformation, description, enabled, newsId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `site-announcements/${newsId}`,
                {
                    "title": title,
                    "authorInformation": authorInformation,
                    "description": description,
                    "enabled": enabled
                }
            ).then(resolve).catch(reject)
        })
    }

}